/*
 * @Author: Scarlett Xiao
 * @Date: 2022-03-04 10:19:05
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-03-07 10:33:24
 */
import http from "@/axios/index";

/**
 * @brief: 年度目标完成情况(汇总、明细)分页-(育苗、养成)
 * @author: Scarlett Xiao
 * @Date: 2022-03-04 10:23:37
 * @param {*} params
 */
export function searchTargetAnalysisGroupList(params) {
  const url = `/mdtTargetAnalysisGroup/searchTargetAnalysisGroupList`;
  return http.post(url, params)
}
/**
 * @brief: 年度目标完成情况（汇总、明细）表-（育苗、养成）导出
 * @author: Scarlett Xiao
 * @Date: 2022-03-04 10:24:17
 */
export function exportTargetAnalysisGroupList() {
  return `/mdtTargetAnalysisGroup/exportTargetAnalysisGroupList`;
}
/**
 * @brief: 区域条件
 * @author: Scarlett Xiao
 * @Date: 2022-03-04 11:12:54
 * @param {*} orgId 机构id
 * @param {*} breedTypeClass fish-养成，egg-育苗
 */
export function getGroupConditions(orgId, breedTypeClass) {
  const params = {
    orgId: orgId,
    breedTypeClass: breedTypeClass
  };
  const url = `/mdtTargetAnalysisGroup/getGroupConditions`;
  return http.post(url, params)
}
/**
 * @brief: 品类条件
 * @author: Scarlett Xiao
 * @Date: 2022-03-04 11:12:54
 * @param {*} orgId 机构id
 * @param {*} breedTypeClass fish-养成，egg-育苗
 */
export function getTypeConditions(orgId, breedTypeClass) {
  const params = {
    orgId: orgId,
    breedTypeClass: breedTypeClass
  };
  const url = `/mdtTargetAnalysisGroup/getTypeConditions`;
  return http.post(url, params)
}
/**
 * @brief: 品种条件
 * @author: Scarlett Xiao
 * @Date: 2022-03-04 11:12:54
 * @param {*} orgId 机构id
 * @param {*} breedTypeClass fish-养成，egg-育苗
 */
export function getBreedConditions(orgId, breedTypeClass) {
  const params = {
    orgId: orgId,
    breedTypeClass: breedTypeClass
  };
  const url = `/mdtTargetAnalysisGroup/getBreedConditions`;
  return http.post(url, params)
}
/**
 * @brief: 造次条件
 * @author: Scarlett Xiao
 * @Date: 2022-03-04 11:12:54
 * @param {*} orgId 机构id
 * @param {*} breedTypeClass fish-养成，egg-育苗
 */
export function getPeriodConditions(orgId, breedTypeClass) {
  const params = {
    orgId: orgId,
    breedTypeClass: breedTypeClass
  };
  const url = `/mdtTargetAnalysisGroup/getPeriodConditions`;
  return http.post(url, params)
}